
export default function Route() {
  const routePoints = [
    { name: 'Salida', location: 'Calle Coso (Teatro Principal)', time: '18:00', icon: 'ri-flag-line' },
    { name: 'Km 1', location: 'Puente de Hierro - Paseo de la Ribera', time: '18:05', icon: 'ri-map-pin-line' },
    { name: 'Km 2', location: 'Avenida de Cataluña - Valle de Zuriza', time: '18:10', icon: 'ri-map-pin-line' },
    { name: 'Km 3', location: 'Caminos del Norte - Martín del Río', time: '18:15', icon: 'ri-map-pin-line' },
    { name: 'Km 4', location: 'Puente de Piedra - Paseo Echegaray', time: '18:20', icon: 'ri-map-pin-line' },
    { name: 'Meta', location: 'Calle Coso', time: '18:25', icon: 'ri-flag-2-line' }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Recorrido de la <span className="text-red-600">Carrera</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
            El recorrido de 5 kilómetros partirá a las 18:00 horas desde el Coso, a la altura del Teatro Principal, 
            cruzará el Puente de Hierro y transcurrirá por paseo de la Ribera y avenida de Cataluña, para llegar a 
            las calles Valle de Zuriza, Caminos del Norte, Martín del Río y Sangüesa Castañosa. Desde ahí, cruzará 
            por el Puente de Piedra, pasando por Paseo de Echegaray y Caballero y San Vicente de Paul hasta culminar 
            de nuevo en el Coso.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Route Timeline */}
          <div className="space-y-6">
            <h3 className="text-2xl font-bold text-gray-900 mb-8">Puntos del Recorrido</h3>
            
            {routePoints.map((point, index) => (
              <div key={index} className="flex items-start space-x-4">
                <div className="flex-shrink-0">
                  <div className={`w-12 h-12 rounded-full flex items-center justify-center ${
                    index === 0 || index === routePoints.length - 1 
                      ? 'bg-red-600 text-white' 
                      : 'bg-red-100 text-red-600'
                  }`}>
                    <i className={`${point.icon} text-lg`}></i>
                  </div>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between">
                    <h4 className="text-lg font-semibold text-gray-900">{point.name}</h4>
                    <span className="text-sm font-medium text-gray-500">{point.time}</span>
                  </div>
                  <p className="text-gray-600 mt-1">{point.location}</p>
                </div>
                {index < routePoints.length - 1 && (
                  <div className="absolute left-6 mt-12 w-0.5 h-6 bg-gray-300"></div>
                )}
              </div>
            ))}
          </div>

          {/* Map and Route Info */}
          <div className="space-y-8">
            {/* Google Maps Embed */}
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2998.5!2d-0.8891!3d41.6488!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd5914dd5e618e91%3A0x9c5df8b2b8b8b8b8!2sCalle%20del%20Coso%2C%20Zaragoza%2C%20Spain!5e0!3m2!1sen!2ses!4v1234567890"
                width="100%"
                height="300"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Mapa del recorrido San Silvestre Zaragoza"
              ></iframe>
            </div>

            {/* Route Stats */}
            <div className="bg-red-600 rounded-2xl p-8 text-white">
              <h4 className="text-2xl font-bold mb-6">Datos del Recorrido</h4>
              <div className="grid grid-cols-2 gap-6">
                <div className="text-center">
                  <div className="text-3xl font-bold mb-2">5 KM</div>
                  <div className="text-white/90">Distancia Total</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold mb-2">~20-40 min</div>
                  <div className="text-white/90">Tiempo Estimado</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold mb-2">Muy fácil</div>
                  <div className="text-white/90">Dificultad</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold mb-2">Nocturno</div>
                  <div className="text-white/90">Horario</div>
                </div>
              </div>
            </div>

            {/* Route Features */}
            <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100">
              <h4 className="text-xl font-bold text-gray-900 mb-4">Características del Recorrido</h4>
              <div className="space-y-3">
                <div className="flex items-center">
                  <i className="ri-road-map-line text-red-600 mr-3"></i>
                  <span className="text-gray-700">Circuito urbano por el centro histórico</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-lightbulb-line text-red-600 mr-3"></i>
                  <span className="text-gray-700">Calles completamente iluminadas</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-shield-check-line text-red-600 mr-3"></i>
                  <span className="text-gray-700">Recorrido seguro y controlado</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-camera-line text-red-600 mr-3"></i>
                  <span className="text-gray-700">Puntos fotográficos emblemáticos</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Additional Info */}
        <div className="mt-16 bg-yellow-50 rounded-2xl p-8 border border-yellow-200">
          <div className="flex items-start">
            <i className="ri-information-line text-2xl text-yellow-600 mr-4 mt-1"></i>
            <div className="flex-1">
              <h4 className="text-xl font-bold text-yellow-800 mb-4">Información Importante</h4>
              <div className="bg-yellow-100 rounded-xl p-6">
                <p className="text-yellow-800 leading-relaxed">
                  <strong>Carrera incluida en el calendario autonómico de carreras populares de Aragón.</strong> La San Silvestre 
                  Zaragoza destaca por su ambiente lúdico y divertido. Además de premiar a los cinco primeros clasificados en las 
                  categorías de hombre y mujer, la empresa patrocinadora, Frutos Secos El Rincón, concederá un premio especial de
                  <strong> pan gratis durante un año al mejor disfraz individual o de grupo</strong>.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
